import React from 'react';
import { Typography, Box } from '@mui/material';

const InvalidLinkNotice: React.FC = () => (
  <Box sx={{ p: 4, maxWidth: 480, mx: 'auto' }}>
    <Typography variant="h5" gutterBottom color="error">
      Invalid Link
    </Typography>
    <Typography variant="body1" color="text.secondary">
      This preview link is missing required information. Please use the link
      from your email.
    </Typography>
  </Box>
);

export default React.memo(InvalidLinkNotice);
